module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visibleBanner) ? _c('div', {
    staticClass: "mt-noti-banner",
    class: 'mt-noti-banner--' + _vm.type
  }, [_c('mt-icon', {
    attrs: {
      "iconName": _vm.iconName,
      "hover": 'not-set',
      "color": _vm.iconColor
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title mt-font--body10"
  }, [_vm._v(_vm._s(_vm.titlePrefix) + ": " + _vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "sub-title mt-font--body10"
  }, [_vm._v(_vm._s(_vm.subTitle))]), _vm._v(" "), (_vm.actionLabel) ? _c('span', {
    staticClass: "action mt-font--body10",
    on: {
      "click": _vm.handleActionClick
    }
  }, [_vm._v(_vm._s(_vm.actionLabel))]) : _vm._e(), _vm._v(" "), _c('mt-icon', {
    staticClass: "close",
    attrs: {
      "iconName": "close"
    },
    on: {
      "click": _vm.handleClickClose
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09130602","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mtui/noti-banner/NotiBanner.vue
// module id = o/l/
// module chunks = 0